module.exports = __webpack_public_path__ + "static/media/obd-mens-fashion-banner.54885827.png";